<template>
  <div class="rate-wrap">
    <span v-if="showScore && direction=='vertical'" class="score-big">{{modelValue}}</span>
    <div class="star-wrap">
      <div class="star" v-for="it in max" :key="it" @click="clickHandler(it)">
        <span class="iconfont" :class="iconClass"></span>
        <template v-if="it <= ceilScore">
          <span
            v-if="it <= intScore"
            style="width: '100%'"
            class="active iconfont"
            :class="iconClass"
          ></span>
          <span
            v-if="remainderPercent != 0"
            :style="{width: it == ceilScore ? remainderPercent+'%' : ''}"
            class="active iconfont"
            :class="iconClass"
          ></span>
        </template>
      </div>
    </div>
    <span v-if="showScore && direction=='horizontal'" class="score">{{modelValue}}</span>
  </div>
</template>

<script>
import { toRefs, ref, onMounted, watch } from 'vue'
export default {
  setup(props) {
    const remainderPercent = ref(0)
    const setRemainder = () => {
      let remainder = (props.modelValue % 1).toFixed(1)
      remainderPercent.value = remainder * 100
    }
    const intScore = ref(0)
    const ceilScore = ref(0)

    const setScore = () => {
      intScore.value = parseInt(props.modelValue)
      ceilScore.value = Math.ceil(props.modelValue)
    }

    const flexDirection = ref('')
    const setFlexDirection = () => {
      if (props.direction == 'vertical') {
        flexDirection.value = 'column'
      }
      if (props.direction == 'horizontal') {
        flexDirection.value = 'row'
      }
    }

    const { modelValue } = toRefs(props)
    watch(modelValue, () => {
      setRemainder()
      setScore()
      setFlexDirection()
    })

    onMounted(() => {
      setRemainder()
      setScore()
      setFlexDirection()
    })

    return {
      intScore,
      ceilScore,
      remainderPercent,
      flexDirection,
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 24,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    color: {
      type: String,
      default: '#FE7700',
    },
    bgColor: {
      type: String,
      default: '#dbdbdb',
    },
    max: {
      type: Number,
      default: 5,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    scoreColor: {
      type: String,
      default: '#fe7700',
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: 'icon-xingxing',
    },
  },
  emits: ['update:modelValue'],
  methods: {
    clickHandler(score) {
      if(this.disabled) return
      this.$emit('update:modelValue', score)
    },
  },
  data() {
    return {
      fontSize: 24
    }
  },
  mounted() {
    this.fontSize = this.size * this.ratio + 'px'
  }
}
</script>

<style scoped>
.rate-wrap {
  display: flex;
  flex-direction: v-bind(flexDirection);
  align-items: center;
}
.score {
  padding-left: 12px;
  font-size: 16px;
  color: v-bind(scoreColor);
  font-weight: bold;
}
.star-wrap {
  display: flex;
  justify-content: space-between;
}
.star {
  margin-right: 8px;
  position: relative;
}
.star span {
  font-size: v-bind (fontSize);
  display: block;
  color: v-bind(bgColor);
  overflow: hidden;
}
.star .active {
  position: absolute;
  top: 0;
  left: 0;
  color: v-bind (color);
}
.score-big {
  font-size: 80px;
  font-weight: bold;
  color: v-bind(scoreColor);
  line-height: 60px;
  padding-bottom: 18px;
}
</style>